'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseScheduledTaskLog', ['$scope', 'LicenseScheduledTaskLogs', function ($scope, LicenseScheduledTaskLogs) {

    }]);